import { Course } from '../types';

export const family_stability_blueprint: Course = {
  id: "family_stability_blueprint",
  title: "Family Stability Blueprint",
  description: "A comprehensive guide to building a stable foundation for your family during proceedings.",
  icon: "🏡",
  totalModules: 15,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    13: { id: 13, title: "Slide 13", slides: [{ title: "Slide 13", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide13.PNG" alt="Slide 13" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    14: { id: 14, title: "Slide 14", slides: [{ title: "Slide 14", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide14.PNG" alt="Slide 14" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    15: { id: 15, title: "Slide 15", slides: [{ title: "Slide 15", content: `<div class="flex justify-center"><img src="/images/courses/family_stability_blueprint/Slide15.PNG" alt="Slide 15" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "Based on 'Architecting the Safety Net,' what are the three core elements of the safety net structure?",
        "o": [
            "Comfort, Communication, and Control",
            "Logistics & Stability, Boundaries, and The Sanctuary",
            "Security, Support, and Structure",
            "Protection, Predictability, and Presence"
        ],
        "a": 1
    },
    {
        "q": "According to the 'Three Load-Bearing Pillars of Family Defense,' what is the primary objective of 'Pillar 1: The Sanctuary Effect'?",
        "o": [
            "Fortifying the Protector",
            "Managing the Environment",
            "Protecting the Child",
            "Bypassing Trauma Gatekeeping"
        ],
        "a": 2
    },
    {
        "q": "In the context of 'Constructing the Emotional Firewall with Sanctuary Rituals,' what defines a 'Temporal Sanctuary'?",
        "o": [
            "A designated physical room or outdoor space that is conflict-free.",
            "Fixed, unalterable routines that provide predictable nervous system regulation.",
            "A communication protocol for managing ex-partner interactions.",
            "The child's ability to express emotions without judgment."
        ],
        "a": 1
    },
    {
        "q": "What is 'The Golden Rule' for tactical redirection out of a conflict zone?",
        "o": [
            "Always engage with the partner's provocation to resolve the issue quickly.",
            "Never participate in a conflict while holding a child or while in their eye line.",
            "Ensure the child understands the conflict before removing them from the situation.",
            "Immediately send the child to their room when a conflict begins."
        ],
        "a": 1
    },
    {
        "q": "When 'Sealing the Perimeter Against Information Leakage' to an ex-partner, what type of information is specifically identified as permissible to share?",
        "o": [
            "Details of current partner's mental health crises.",
            "Personal stress and household tension.",
            "Pure logistics like schedules, school updates, and medical necessities.",
            "Grievances about past relationship issues."
        ],
        "a": 2
    },
    {
        "q": "According to 'Stabilizing the Gravity of the Favorite Parent Trap,' why do children naturally gravitate towards one parent who provides a predictable, stable baseline?",
        "o": [
            "It is a deliberate act of manipulation by the child.",
            "It is a healthy biological survival mechanism.",
            "They are actively trying to alienate the unstable partner.",
            "The stable parent is subtly encouraging this behavior."
        ],
        "a": 1
    },
    {
        "q": "What does 'Trauma Gatekeeping' primarily prevent in a household with an unstable partner, as described in 'Bypassing Anxiety-Driven Parenting Gatekeeping'?",
        "o": [
            "The unstable partner from seeking professional help.",
            "The primary functioning parent from delegating tasks and establishing independent routines.",
            "The child from forming attachments with the unstable parent.",
            "Effective communication between the co-parents."
        ],
        "a": 1
    },
    {
        "q": "In 'The Stepped Pathway to Reclaiming Parenting Autonomy,' what is the purpose of 'Micro-Separations'?",
        "o": [
            "To establish baseline safety and proven competence with the anxious partner.",
            "To fully re-establish normal, independent parenting operations.",
            "To desensitize the partner's abandonment triggers through quick returns after strict 10-minute absences.",
            "To take total ownership of longer temporal blocks of solo parenting."
        ],
        "a": 2
    },
    {
        "q": "What is the primary role of 'The External Relief Valve' in 'The Logistics Dashboard for Solo Parenting in a Two-Parent Home'?",
        "o": [
            "To manage sleep shifts for the primary parent during crises.",
            "To provide pre-planned, zero-bandwidth meals.",
            "To ensure consistent emotional support from the unstable partner.",
            "To deploy a pre-vetted, on-call roster of emergency childcare contacts to prevent system collapse."
        ],
        "a": 3
    },
    {
        "q": "When 'Operating as the Stabilizing Witness with Clinical Teams,' what communication trait is described as most effective for the primary parent?",
        "o": [
            "Highly emotional delivery, actively diagnosing the partner, and assigning blame.",
            "Providing purely factual, calm observations and timeline-based data.",
            "Listing exhaustive past relationship grievances.",
            "Expressing frustration and anger about the partner's behavior."
        ],
        "a": 1
    }
]
};
